cv.DashboardProgressView = Marionette.LayoutView.extend({
  tagName: 'a',
  className: 'member',

  getTemplate: function(){
    return cv.Templates['dashboard/progress'];
  },

  bindings : {
    ':el' : {
      observe : 'photo_path',
      update: function($el, value, model, options) {
        var $replace = $el.find('.profile-photo').clone();

        if(this.options.type == 'project'){
          $replace.attr('data-src', cv.photo({
            photo_path : model.get('user.photo_path'),
            photo_default : cv.campaign.get('default_fundraiser_photo'),
            url_only : true,
            transforms : {
              fit : 'crop'
            }
          }));
        }else{
          $replace.attr('data-src', cv.photo({
            photo_path : model.get('photo_path'),
            photo_default : cv.campaign.get('default_team_photo'),
            url_only : true,
            transforms : {
              fit : 'crop'
            }
          }));
        }
        
        $el.find('.profile-photo').replaceWith($replace);

        setTimeout(_.bind(function(){
          imgix.fluid($el.get(0), {
            updateOnResizeDown: false,
            pixelStep: 5,
            autoInsertCSSBestPractices: true
          });
        }, this), 50);
      }
    }
  },

  events: {
    'click .edit-team' : 'editTeam'
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    console.log('DashboardProgressView initialized');
  },

  templateHelpers: function () {
    var percent_progress = Math.round(this.model.get('funds_raised')/this.model.get('funds_needed') * 100);
    if(percent_progress > 100){
      percent_progress = 100;
    }

    return {
      is_fundraiser : this.options.type == 'project' ? true : false,
      is_team : this.options.type == 'team' ? true : false,
      name : this.options.type == 'team' ?  this.model.get('name') : this.model.get('display_name'),
      tag : this.options.type == 'team' ?  'TEAM' : 'FUNDRAISER',
      url : this.model.get('url'),
      stub : this.model.get('stub'),
      meta : cv.formatMoney({
        show_sign : true,
        amount : this.model.get('funds_raised'),
        currency_code : cv.campaign.get('currency_code'),
        decimal_places : 2
      }) + ' Raised',
      percent_progress : percent_progress,
      funds_raised : cv.formatMoney({
        show_sign : true,
        amount : this.model.get('funds_raised'),
        currency_code : cv.campaign.get('currency_code'),
        decimal_places : 2
      }),
      funds_needed : cv.formatMoney({
        show_sign : true,
        amount : this.model.get('funds_needed'),
        currency_code : cv.campaign.get('currency_code'),
        decimal_places : 2
      }),
      num_donations : this.model.get('num_donations'),
      show_progress : this.options.type == 'project' || (cv.campaign.get('enable_team_funds_raised') == 1 && this.model.get('funds_needed') > 0) ? true : false
    };
  },

  onAttach: function(){
    if(this.options.type == 'team' && this.options.active == false){
      this.$el.attr('data-bypass', true);
      this.$el.attr('href', '/team/' + this.model.get('stub') + '/admin/dashboard');
    }
    if(this.options.type == 'project' && this.options.active == false){
      this.$el.attr('data-bypass', true);
      this.$el.attr('href', '/' + cv.project.get('stub') + '/admin/dashboard');
    }
    
    if(this.options.active == true){
      this.$('.actions').hide();
    }
  },

  onShow: function(){
    this.stickit(this.model);
  }
});
